// export const backendIP = "http://192.168.1.198:9999"
export const backendIP = "https://mavlink.techeagle.in"

// export const backendIP = "https://sitl.techeagle.org"